import {ExportColumnFormatterType} from 'asax-common';
import {FrequencySupportFormatter} from './formatters/frequency.support.formatter';

export interface ExportColumnFormatter {
  format(row: any): any;
}

export class ExportColumnFormatterFactory {
  getFormatter(exportColumnFormatterType: ExportColumnFormatterType): ExportColumnFormatter {
    switch (exportColumnFormatterType) {
      case 'frequency-support':
        return new FrequencySupportFormatter();
      default:
        return undefined;
    }
  }
}
